import { render, staticRenderFns } from "./GCCDetail.vue?vue&type=template&id=35288477&"
import script from "./GCCDetail.vue?vue&type=script&lang=js&"
export * from "./GCCDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports